import { render, staticRenderFns } from "./ForgotLoginId.vue?vue&type=template&id=6d091735&scoped=true&"
import script from "./ForgotLoginId.vue?vue&type=script&lang=js&"
export * from "./ForgotLoginId.vue?vue&type=script&lang=js&"
import style0 from "./ForgotLoginId.vue?vue&type=style&index=0&id=6d091735&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d091735",
  null
  
)

export default component.exports